import createSafeStorage from './safeStorageCreator';

export default createSafeStorage('localStorage');
